import React, { Suspense, useRef } from 'react';
import PropTypes from 'prop-types';
import { FloatingCommentButton } from '@contently/toolkit';
import useTextEditorAnnotations from '../../hooks/useTextEditorAnnotations';
import FloatingCommentForm from './FloatingCommentForm';
import useOutsideClick from '../../hooks/useOutsideClick';
import TextEditorAnnotationComment from './TextEditorAnnotationComment';
import useStoryContext from '../../hooks/useStoryContext';

export default function TextEditorAnnotations({
  consumerApi,
  contentId,
  allContentIds,
  positionContainerRef,
  storyId
}) {
  const {
    showCommentButton,
    setShowCommentButton,
    showCommentForm,
    activeAnnotation,
    setActiveAnnotation,
    yPos,
    handleNewAnnotation,
    handleRemoveAnnotation,
    handleSubmitComment,
    handleCancelComment
  } = useTextEditorAnnotations(consumerApi, contentId, allContentIds, positionContainerRef);

  const { mentionableUsersBasicInfo } = useStoryContext();

  const hideComment = () => {
    setActiveAnnotation(null);
    handleCancelComment();
  };

  const commentButtonRef = useRef(null);
  useOutsideClick(commentButtonRef, () => setShowCommentButton(false));

  return (
    <React.Fragment>
      {showCommentButton && (
        <div ref={commentButtonRef} className="floating-container-wrapper">
          <FloatingCommentButton right={-72} top={yPos} onClick={handleNewAnnotation} />
        </div>
      )}
      {showCommentForm && (
        <FloatingCommentForm
          yPos={yPos}
          handleSubmitComment={handleSubmitComment}
          handleCancelComment={handleCancelComment}
          users={mentionableUsersBasicInfo}
        />
      )}
      {activeAnnotation && (
        <Suspense fallback={null}>
          <div className="floating-container-wrapper">
          <TextEditorAnnotationComment
            allContentIds={allContentIds}
            activeAnnotation={activeAnnotation}
            handleRemoveAnnotation={handleRemoveAnnotation}
            yPos={yPos}
            hide={hideComment}
            storyId={storyId}
            users={mentionableUsersBasicInfo}
          />
          </div>
        </Suspense>
      )}
    </React.Fragment>
  );
}

TextEditorAnnotations.propTypes = {
  contentId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  consumerApi: PropTypes.any.isRequired,
  allContentIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  positionContainerRef: PropTypes.object.isRequired,
  storyId: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/TextEditorAnnotations.jsx